import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { StoPipesModule } from '@ngx-stoui/core';
import { ReleaseNote } from './models';

@Component({
    template: `<h3 mat-dialog-content>Release notes - {{ data.date | formatDate }}</h3>
    <mat-dialog-content>
      <p>{{ data.content }}</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button [mat-dialog-close]="null" color="primary" mat-button>Close</button>
    </mat-dialog-actions> `,
    imports: [MatDialogModule, StoPipesModule, MatButtonModule]
})
export class ReleaseNoteDialogComponent {
  public data: ReleaseNote = inject(MAT_DIALOG_DATA);
}
